export const boostrapConfig = {
    appId: 1166,
    mode: "",
    env: "production",
    api: {
        url: "https://api.communico.co/v4",
        ssoUrl: 'https://control-us.communico.co/sso/go',
        authentication: {
            key: "JmxzzJ30L5B70buTDeAz",
            secret: "LwHCTIxHTKuFUeqkYSOw",
        }
    }
};
export const androidStatusBarColor = "#000000";



// WEBPACK FOOTER //
// ./src/config/index.ts